import { PaymentMethods } from '@/interfaces/enums';
import { PosSyncPaymentEmit } from '@/interfaces/models/posSync';
import numberUtils from '@/utils/number.utils';

export function buildSyncPaymentEmit(
  paymentMethod: string | null,
  card: number | string,
  orderAmount: number,
  currency: string,
  discount: number | null,
): PosSyncPaymentEmit | null {
  if (paymentMethod === PaymentMethods.CASH || paymentMethod === PaymentMethods.TEST) {
    return {
      event: 'toOpenPaymentByCash',
      data: {
        amount: orderAmount,
        currency,
        discount,
      },
    };
  }

  if (paymentMethod === PaymentMethods.CARD) {
    return {
      event: 'toOpenPaymentByCard',
      data: {
        amount: orderAmount,
        currency,
        discount,
      },
    };
  }

  if (paymentMethod === PaymentMethods.MIXED) {
    const cardAmount = numberUtils.correctFloatNumber(Number(card) || 0);
    const cashAmount = numberUtils.correctFloatNumber(Math.max(orderAmount - cardAmount, 0));

    return {
      event: 'toOpenMixedPayment',
      data: {
        cash: cashAmount,
        card: cardAmount,
        currency,
        discount,
      },
    };
  }

  return null;
}

export default {
  buildSyncPaymentEmit,
};
